import api from '@/services/api'

type Social = {
  platform: 'instagram' | 'linkedin' | 'tiktok' | 'other'
  handle: string
  url: string
}

type PreRegisterPayload = {
  influencer: {
    accepted_terms_of_use: boolean
    name: string
    email: string
    phone: string
    password: string
    password_confirmation: string
    social_networks?: Social[]
  }
}

export const preRegisterInfluencer = (payload: PreRegisterPayload) => {
  return api
    .post('/influencers/pre_registration', payload, {
      headers: {
        'Content-Type': 'application/json',
        'jwt-aud': 'web.app.client',
      },
    })
    .then(r => r.data)
}
